module.exports = "/images/vendor/flag-icon-css/flags/1x1/ki.svg?cdeef8df88cfea2b6759b528b41f0d88";